import { render, staticRenderFns } from "./CreateBulkActionContext.vue?vue&type=template&id=21c6feb7&scoped=true&"
import script from "./CreateBulkActionContext.vue?vue&type=script&lang=ts&"
export * from "./CreateBulkActionContext.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBulkActionContext.vue?vue&type=style&index=0&id=21c6feb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c6feb7",
  null
  
)

export default component.exports